// 常量
export const SOFTWARE_PROJECT_ID = 238;
export const SOFTWARE_PROJECT_NAME = "TeamERP";